import { GetStaticProps } from 'next'

import Filter from 'src/pages/Filter/index'
import { getSitePageBuilderStaticProps } from 'src/pageBuilder/sitePageBuilder'

export default Filter

export const getStaticProps: GetStaticProps = getSitePageBuilderStaticProps
